import { memo } from 'react';
import { Grid, Typography } from '@mui/material';
import { InvestmentDTO } from '@inversor-hub/types';
import { formatCurrency, formatPercentage } from '@/utils/misc';
import { GlossaryHelp } from '../../shared/GlossaryHelp';
import { KpiCard } from '../../shared/KpiCard';

interface ForecastCardsProps {
  investment: InvestmentDTO;
}

const FROM_RECORD = 'Según los datos de la ficha';

export const ForecastCards = memo(({ investment }: ForecastCardsProps) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6} md={3}>
      <KpiCard
        label="Rentabilidad bruta"
        help={<GlossaryHelp term="grossReturn" />}
        caption={FROM_RECORD}
      >
        <Typography variant="h4" fontWeight={700} color="success.main">
          {formatPercentage(investment.grossReturn)}
        </Typography>
      </KpiCard>
    </Grid>

    <Grid item xs={12} sm={6} md={3}>
      <KpiCard
        label="Rentabilidad neta"
        help={<GlossaryHelp term="netReturn" />}
        caption="Ya con los gastos corrientes descontados"
      >
        <Typography variant="h4" fontWeight={700} color="primary.main">
          {formatPercentage(investment.netReturn)}
        </Typography>
      </KpiCard>
    </Grid>

    {investment.monthlyRent != null ? (
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          label="Renta mensual"
          help="Ingreso mensual por el alquiler previsto en la ficha de la inversión."
          caption={`${formatCurrency(investment.monthlyRent * 12)} al año`}
        >
          <Typography variant="h4" fontWeight={700}>
            {formatCurrency(investment.monthlyRent)}
          </Typography>
        </KpiCard>
      </Grid>
    ) : null}

    {investment.monthlyCashflow != null ? (
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          label="Cashflow mensual"
          help={<GlossaryHelp term="cashflow" />}
          caption={`${formatCurrency(investment.monthlyCashflow * 12)} al año`}
        >
          <Typography
            variant="h4"
            fontWeight={700}
            color={investment.monthlyCashflow >= 0 ? 'success.main' : 'error.main'}
          >
            {formatCurrency(investment.monthlyCashflow)}
          </Typography>
        </KpiCard>
      </Grid>
    ) : null}
  </Grid>
));

ForecastCards.displayName = 'ForecastCards';
